<template>
  <div 
    class="comments"
    :class="isFullHeightEmbedded ? 'd-flex flex-column h-100' : ''"
  >
    <h2 
        v-if="isNeedHeader"
        class="mb-3"
    >
        Комментарии к услуге
    </h2>
    <template v-if="isChatLoading">
        <div class="text-center text-success mt-5 mb-3">
            <b-spinner variant="success"></b-spinner>
          </div>
          <div class="text-center">Загружаем сообщения...</div>
    </template>
    <template v-else>
        <div
            :class="isFullHeightEmbedded ? 'history py-0 px-1 h-100' : ''"
        >
            <template v-if="comments.length == 0">
                <p class="text-center text-muted pt-3">Комментарии по услуге отсутствуют.</p>
            </template>

            <Comment
                v-for="comment in comments"
                :key="comment.id"
                :id-comment="comment.id"
                :created-at="comment.created_at"
                :user-id="comment.creator_user_id"
                :text="comment.comment"
                :parent_comment="comment.parent_comment"
                :files="comment.files"
                class="comment"
                @editComment="editComment(comment)"
                @replyComment="replyComment(comment)"
                @remove="removeComment"
                @scrollToRepliedComment="scrollToRepliedComment"
            />
        </div>

        <template v-if="!isAgent && !isClient">
          <CommentSubmitForm
            class="submit-form"
            no-focus
            :needFileUploadButton="true"
            :loading="savingComment"
            :id-comment="idComment"
            :is-reply="isReply"
            :text="text"
            :old-value="oldValue"
            :is-need-to-refresh="isNeedToRefresh"
            @addFiles="addFiles"
            @submit="submitComment"
            @cancelReplyOrEdit="cancelReplyOrEdit"
            @setReplyComment="setReplyComment"
            @setEditComment="setEditComment"
            @refreshed="refreshed"
          />          
        </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Comment from "@components/comments/Comment.vue";
import CommentSubmitForm from "@components/comments/CommentSubmitForm";
import { mixinComments } from "@/mixins/mixinComments";

export default {
  mixins: [mixinComments],

  props: {
    isNeedHeader: {
      type: Boolean,
      default: true,
    },
    isFullHeightEmbedded: {
      type: Boolean,
      default: false,
    },
    orderServiceId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isChatLoading: true,
      comments: [],
      files: [],
      savingComment: false,
      apiName: 'service',
      idName: 'order_service_id',
    };
  },

  components: {
    Comment,
    CommentSubmitForm,
  },

  computed: {
    ...mapGetters("auth", ["currentUser"]),
    
    isAgent() {
      return this.currentUser.role.includes('agent');
    },
    isClient() {
      return this.currentUser.role.includes('client');
    },

    currentId() {
      return this.orderServiceId;
    }
  },

  methods: {
    async fetchComments() {
      this.isChatLoading = true;
      this.comments = await this.$api.service.getComments(this.orderServiceId);
      this.isChatLoading = false;
    },

    removeComment(id) {
      this.editCommentStatus = true;
      this.$api.service.removeComment(id).then(() => {
        this.fetchComments();
      });
    },
  },

  async mounted() {
    this.fetchComments();
  },
};
</script>

<style lang="scss" scoped>
.comment {
  margin-bottom: 10px;
  background: #f3f3f3;
}
.history {
    overflow-x: hidden;
}
.history::-webkit-scrollbar {
    width: 6px;
    border-radius: 6px !important;
}
.history::-webkit-scrollbar-thumb {
    border-radius: 6px !important;
}
</style>
